import React from 'react';
import { useNavigate } from 'react-router-dom';

const CancellationPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 md:p-8">
        {/* Back button */}
        <button 
          onClick={() => navigate(-1)} 
          className="mb-8 flex items-center text-[#002E62] hover:text-[#f26522] transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back
        </button>

        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Cancellation & Refund Policy</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Overview</h2>
          <p className="mb-4">
            At Surya Media ("we", "our", or "us"), we value your trust and are committed to providing a transparent and fair cancellation and refund process. This policy explains how cancellations, returns, and refunds are handled when you use our services or purchase our products.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Cancellation Policy</h2>
          <p className="mb-4">
            You may cancel your order or service request within <strong>24 hours of placing it</strong>, provided that it has not already been processed, shipped, or delivered. Once an order is processed, cancellation requests cannot be accommodated.
          </p>
          <p className="mb-4">
            To request a cancellation, please contact us promptly via email or phone with your order details.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Refund Policy</h2>
          <p className="mb-2">Refunds may be issued under the following circumstances:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Order canceled within the allowed cancellation period</li>
            <li>Duplicate payment made due to technical error</li>
            <li>Product/service not delivered as promised</li>
            <li>Defective or damaged product received (with proof required)</li>
          </ul>
          <p className="mb-4">
            Refunds will be processed within <strong>7-10 business days</strong> from the date of approval. Refunds will be credited to the original mode of payment only.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Non-Refundable Situations</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>Orders canceled after the processing/shipping stage</li>
            <li>Customized services already delivered</li>
            <li>Digital services/reports once shared with the customer</li>
            <li>Delay caused by incorrect or incomplete information provided by the customer</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">5. How to Request a Cancellation or Refund</h2>
          <p className="mb-4">
            To request a cancellation or refund, please reach out to us with the following details:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Order number</li>
            <li>Full name</li>
            <li>Reason for cancellation/refund</li>
            <li>Supporting documents (if applicable)</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">6. Contact Us</h2>
          <p className="mb-4">
            For any questions about this Cancellation & Refund Policy, please contact us at:
          </p>
          <p className="mb-4">
            Surya Media<br />
            Madhapur, Hyderabad, Telangana 500018<br />
            Email: suryamedia54@gmail.com<br />
            Phone: +91 81859 22222
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
